import React from "react";
import { Box, Typography, makeStyles } from "@material-ui/core";
// Local
import sendImg from "../../assets/images/send_customer_form.png";
//import startImg from "../../assets/images/start_customer_form.png";
import serviceImg from "../../assets/images/service-appraisal.svg";
import leaseImg from "../../assets/images/lease-return.svg";
import tradeInImg from "../../assets/images/trade-in.svg";
import { NewAppraisalButton } from "../../dialogs/NewAppraisalDialog";
import { InviteCustomerButton } from "../../forms";
import {
  authSelectors,
  // useDealer,
  useSelector,
} from "../../state";
import { useMobile } from "../../themes";
import OpportunitiesContainer from "../../components/draggable/OpportunitiesContainer";

const useStyles = makeStyles(
  theme => ({
    root: {},
    subtitle: {
      color: theme.palette.text.primary,
      fontSize: 16,
      marginTop: theme.spacing(1),
      fontWeight: 400,
    },
    content: {
      display: "flex",
      paddingTop: 40,
      justifyContent: "space-around",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
      },
      [theme.breakpoints.down("md")]: {
        flexWrap: "wrap",
      },
    },
    card: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "40px 0",
      height: 270,
      width: 312,
      border: "1px solid #BBC2E1",
      borderRadius: 3,
      marginRight: 40,
      backgroundColor: theme.palette.background.default,
      [theme.breakpoints.down("md")]: {
        width: "45%",
        marginBottom: theme.spacing(3),
      },
      [theme.breakpoints.down("sm")]: {
        width: "100%",
        marginBottom: theme.spacing(3),
      },
    },
    button: {
      height: 48,
      minWidth: 212,
      borderRadius: 3,
      backgroundColor: theme.palette.secondary.main,
      color: "#FFFFFF",
      fontSize: 16,
      fontWeight: 500,

      "&:hover": {
        backgroundColor: "#B5C1FF",
        color: theme.palette.text.primary,
      },
    },
    bgImg: {
      position: "fixed",
      bottom: 0,
      right: 0,
      zIndex: -1,
    },
  }),
  {
    classNamePrefix: "NewOpportunityPage",
  },
);

// function getFormHref({ isLeaseReturn, dealer, user }) {
//   return `${APPRAISAL_APP_URL}/${isLeaseReturn ? "return" : "sell"}?dealer=${
//     dealer.id
//   }${user.uid ? "&duid=" + user.uid : ""}`;
// }

export const NewOpportunityPage = React.memo(
  /**
   *
   */
  function NewOpportunityPage() {
    const classes = useStyles();
    const isMobile = useMobile();

    const user = useSelector(authSelectors.user);
    const allowService = useSelector(authSelectors.allowService);
    const onlyService = useSelector(authSelectors.onlyService);

    return (
      <div className={classes.root}>
        <Typography variant="h2">Welcome {user.firstName}</Typography>
        <div className={classes.subtitle}>What would you like to do today?</div>
        <div className={classes.content}>
          {!onlyService && (
            <>
              <div className={classes.card}>
                <img
                  height="100"
                  width="121"
                  src={sendImg}
                  alt="Share customer form"
                />
                <InviteCustomerButton className={classes.button} />
              </div>
              <div className={classes.card}>
                <img
                  height="105"
                  width="89"
                  src={tradeInImg}
                  alt="Start a new trade-in"
                />
                <NewAppraisalButton className={classes.button} type="tradein" />
              </div>
              <div className={classes.card}>
                <img
                  height="105"
                  width="89"
                  src={leaseImg}
                  alt="Start a new lease return"
                />
                <NewAppraisalButton className={classes.button} type="lease" />
              </div>
            </>
          )}
          {allowService && (
            <div className={classes.card}>
              <img
                height="105"
                width="89"
                src={serviceImg}
                alt="Start a service appraisal"
              />
              <NewAppraisalButton className={classes.button} isService>
                Start service appraisal
              </NewAppraisalButton>
            </div>
          )}
        </div>
        <OpportunitiesContainer />
        {isMobile ? (
          ""
        ) : (
          <Box className={classes.bgImg}>
            <img
              alt="Appraisal dashboard"
              height="380"
              src="/images/NewOpportunityBg.png"
              width="700"
            />
          </Box>
        )}
      </div>
    );
  },
);
